import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
var RubriqLoadingSpinner = function RubriqLoadingSpinner(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'loading' : _ref$text;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column justify-content-center align-items-center gap-2 rubriq-loading-spinner-container",
    style: {
      fontSize: '20px'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-duotone fa-solid fa-spinner-third",
    spin: true,
    style: {
      color: '#027e6f'
    }
  }), /*#__PURE__*/React.createElement(T, {
    source: text
  }));
};
export default RubriqLoadingSpinner;